import { useCallback, useEffect, useState } from 'react';
import { api, ApiError } from '../api/client';
import { useAuth } from './useAuth';
import type { InventoryResult } from '../api/types';

/**
 * O inventário do cliente, já cotado, com a leitura sob controle de quem usa.
 *
 * Mora num hook porque a venda e o upgrade mostram a mesma lista em telas
 * bem diferentes — a de venda em página cheia, a do upgrade como coluna. O que
 * as duas compartilham é só a busca e o motivo de cada item entrar ou não.
 */
export function useInventario() {
  const { user, loading: carregandoConta, loginUrl } = useAuth();
  const [data, setData] = useState<InventoryResult | null>(null);
  const [erro, setErro] = useState<string | null>(null);
  const [carregando, setCarregando] = useState(false);

  const carregar = useCallback(async (force = false) => {
    setCarregando(true);
    setErro(null);
    try {
      setData(await api.inventory(force));
    } catch (e) {
      setErro(e instanceof ApiError ? e.message : 'Não consegui ler o seu inventário.');
    } finally {
      setCarregando(false);
    }
  }, []);

  // Sem trade link não há o que cotar: a conta ainda está pela metade.
  useEffect(() => {
    if (user && !user.needsOnboarding) void carregar();
  }, [user, carregar]);

  return { user, carregandoConta, loginUrl, data, erro, carregando, carregar };
}
